import {createActions} from 'client/framework';

export default createActions(null, ['SET_ENABLED']);
